import Images from "../../../assets/ImageSkills";

export const frontSkills = [
  { name: "HTML5", img: Images.html5 },
  { name: "CSS3", img: Images.css3 },
  { name: "JavaScript", img: Images.javascript },
  { name: "TypeScript", img: Images.typescript },
  { name: "React", img: Images.react },
  { name: "VueJs", img: Images.vuejs },
  { name: "Material UI", img: Images.mui },
  { name: "Figma", img: Images.figma },
];

export const toolsSkills = [
  { name: "MySql", img: Images.mysql },
  { name: "Postman", img: Images.postman },
  { name: "Git", img: Images.git },
  { name: "GitHub", img: Images.github },
];
